import { ServiceContentResponseDTO } from "../../../requests-module"
import {ref, Ref} from "vue"

const serviceContentResponses: Ref<ServiceContentResponseDTO> = ref(new ServiceContentResponseDTO({}))

export default serviceContentResponses